import React, { useEffect, useState } from "react";
import AxiosInstance from "../Home/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiEdit, FiTrash } from "react-icons/fi";
import TraineeHeader from "./TraineeHeader";
import Footers from "../Home/Footers";
import profile from "../Home/Profile.png";
import "./traineePortal.css";
import "./TraineeDetails.css";
import { useTable, useGlobalFilter, useSortBy, useResizeColumns, usePagination} from "react-table";
import {
  dayAfterInputValue,
  todayInputValue,
  toDateInputValue,
  validateCertificationDates,
  validateEducationDates,
  yearsFromTodayInputValue,
} from "./dateUtils";

export default function TraineeDetails() {
  const [trainee, setTrainee] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedTrainee, setEditedTrainee] = useState({});
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(null);
  const [addressTypeOptions, setAddressTypeOptions] = useState([]);
  const [address, setAddress] = useState([]);
  const [education, setEducation] = useState([]);
  const [editingAddress, setEditingAddress] = useState(null);
  const [editedAddress, setEditedAddress] = useState(null);
  const [addressFilter, setAddressFilter] = useState("");
  const [editAddressSearch, setEditAddressSearch] = useState("");
  const [editSuggestions, setEditSuggestions] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [editingEducation, setEditingEducation] = useState(null);
  const [editedEducation, setEditedEducation] = useState(null);
  const [educationFilter, setEducationFilter] = useState("");
  const [certification, setCertification] = useState([]);
  const [certificationOptions, setCertificationOptions] = useState([]);
  const [editingCertification, setEditingCertification] = useState(null);
  const [editedCertification, setEditedCertification] = useState(null);
  const [certificationFilter, setCertificationFilter] = useState("");
  const [skill, setSkill] = useState([]);
  const [skillOptions, setSkillOptions] = useState([]);
  const [editingSkill, setEditingSkill] = useState(null);
  const [editedSkill, setEditedSkill] = useState(null);
  const [skillFilter, setSkillFilter] = useState("");
  const [socialLink, setSocialLink] = useState([]);
  const [editingSocialLink, setEditingSocialLink] = useState(null);
  const [editedSocialLink, setEditedSocialLink] = useState(null);
  const [socialLinkFilter, setSocialLinkFilter] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const traineeId = localStorage.getItem("traineeId");

    if (traineeId) {
      AxiosInstance.get(`companies/trainee-details/${traineeId}`)
        .then((response) => {
          setTrainee(response.data);
          setEditedTrainee(response.data);
        })
        .catch((error) => {
          console.error("Error fetching trainee details:", error);
        });
    }
  }, []);

  const openModal = () => {
    setEditedTrainee(trainee);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    setEditedTrainee({ ...editedTrainee, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    const traineeId = localStorage.getItem("traineeId");
    const formData = new FormData();

    formData.append("first_name", editedTrainee.first_name);
    formData.append("last_name", editedTrainee.last_name);
    formData.append("email", editedTrainee.email);
    formData.append("mobile_no", editedTrainee.mobile_no);
    formData.append("gender", editedTrainee.gender || "");
    formData.append("dob", editedTrainee.dob || "");

    if (editedTrainee.image_file) {
      formData.append("image", editedTrainee.image_file);
    }

    AxiosInstance.put(`companies/update-trainee/${traineeId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        setTrainee(response.data);
        closeModal();
      })
      .catch((error) => {
        console.error("Error updating trainee:", error);
      });
  };

  useEffect(() => {
    const fetchStatesAndCountries = async () => {
      try {
        console.log("Fetching countries...");
        const countriesResponse = await AxiosInstance.get(
          "companies/countries/"
        );
        setCountries(countriesResponse.data || []);

        if (country) {
          const statesResponse = await AxiosInstance.get(
            `companies/states/${country}/`
          );
          setStates(statesResponse.data || []);
        }
      } catch (error) {
        console.error("Error fetching states and countries:", error);
      }
    };

    fetchStatesAndCountries();
  }, [country]);

  useEffect(() => {
    const fetchAddressTypes = async () => {
      try {
        const response = await AxiosInstance.get("companies/address/types/");
        if (response.status === 200) {
          setAddressTypeOptions(response.data);
        } else {
          console.error("Failed to fetch address types");
        }
      } catch (error) {
        console.error("Error fetching address types:", error);
      }
    };

    fetchAddressTypes();
  }, []);

  useEffect(() => {
    const traineeId = localStorage.getItem("traineeId");
    if (!traineeId) {
      alert("trainee ID is missing. Please log in.");
      return;
    }

    const fetchAddress = async () => {
      try {
        const addressResponse = await AxiosInstance.get(
          `companies/address/${traineeId}`
        );
        setAddress(addressResponse.data || []);
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    };

    fetchAddress();
  }, []);

  const handleAdd = (section) => {
    navigate(`/trainee-${section}`);
  };

  useEffect(() => {
    if (!editAddressSearch) {
      setEditSuggestions([]);
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        const res = await AxiosInstance.get("companies/get-address/", {
          params: { address: editAddressSearch },
        });
        setEditSuggestions(res.data.suggestions || []);
      } catch (err) {
        console.error("Edit autocomplete failed", err);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [editAddressSearch]);

  const handleEditAddressSelect = async (placeId) => {
    setEditSuggestions([]);
    setEditAddressSearch("");

    try {
      const res = await AxiosInstance.get("companies/get-address-details/", {
        params: { placeId },
      });

      const data = res.data;

      const matchedCountry = countries.find(
        (c) => c.country_name === data.country
      );
      const matchedState = states.find((s) => s.state_name === data.state);

      setEditedAddress((prev) => ({
        ...prev,
        address_line1: data.addressLine1 || "",
        address_line2: data.addressLine2 || "",
        city: data.city || "",
        zip_code: data.postalCode || "",
        country: matchedCountry ? matchedCountry.country_id : "",
        state: matchedState ? matchedState.state_id : "",
      }));
    } catch (err) {
      console.error("Error fetching address details", err);
    }
  };

  const handleEditAddress = (index) => {
    const addressToEdit = address[index];

    setEditingAddress(addressToEdit);
    setEditedAddress({
      ...addressToEdit,
      country: addressToEdit.country?.country_id || "",
      state: addressToEdit.state?.state_id || "",
      address_type: addressToEdit.address_type?.address_type_id || "",
    });

    setCountry(addressToEdit.country?.country_id || "");
  };

  const handleAddressInputChange = (e) => {
    const { name, value } = e.target;
    setEditedAddress({
      ...editedAddress,
      [name]: value,
    });
  };

  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    setCountry(countryId);
    setEditedAddress({ ...editedAddress, country: countryId });
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setEditedAddress({ ...editedAddress, state: stateId });
  };

  const handleAddressTypeChange = (e) => {
    const typeId = e.target.value;
    setEditedAddress({ ...editedAddress, address_type: typeId });
  };

  const handleSaveAddress = async () => {
    if (!editedAddress?.address_id) return;

    const payload = {
      address_line1: editedAddress.address_line1,
      address_line2: editedAddress.address_line2,
      city: editedAddress.city,
      zip_code: editedAddress.zip_code,
      state: editedAddress.state,
      country: editedAddress.country,
      address_type: editedAddress.address_type,
    };

    try {
      await AxiosInstance.put(
        `companies/address/${editedAddress.address_id}/`,
        payload
      );

      // NEW FIX ↓↓↓
      const selectedCountryObj = countries.find(
        (c) => c.country_id == editedAddress.country
      );
      const selectedStateObj = states.find(
        (s) => s.state_id == editedAddress.state
      );
      const selectedAddressTypeObj = addressTypeOptions.find(
        (a) => a.address_type_id == editedAddress.address_type
      );

      const updatedAddresses = address.map((addr) =>
        addr.address_id === editedAddress.address_id
          ? {
              ...addr,
              ...payload,
              country: selectedCountryObj || {},
              state: selectedStateObj || {},
              address_type: selectedAddressTypeObj || {},
            }
          : addr
      );

      setAddress(updatedAddresses);
      setEditingAddress(null);
    } catch (error) {
      console.error("Error saving address:", error);
    }
  };

  const handleRemoveAddress = async (index) => {
    const addressIdToRemove = address[index]?.address_id;

    if (!addressIdToRemove) {
      console.error("Address ID is missing.");
      return;
    }

    // Confirm with user
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this address?"
    );
    if (!isConfirmed) {
      console.log("Address removal canceled.");
      return;
    }

    try {
      // Delete from backend
      await AxiosInstance.delete(
        `companies/trainee-address/${addressIdToRemove}`
      );

      // Update local state
      const updatedAddresses = [...address];
      updatedAddresses.splice(index, 1);
      setAddress(updatedAddresses);

      console.log("Address removed successfully.");
    } catch (error) {
      console.error("Error removing address:", error);
    }
  };

  const addressColumns = React.useMemo(
    () => [
      { Header: "Address Line 1", accessor: "address_line1" },
      { Header: "Address Line 2", accessor: "address_line2" },
      { Header: "City", accessor: "city" },
      { Header: "State", accessor: (d) => d.state?.state_name || "" },
      { Header: "Country", accessor: (d) => d.country?.country_name || "" },
      { Header: "Zip Code", accessor: "zip_code" },
      {
        Header: "Address Type",
        accessor: (d) => d.address_type?.address_type || "",
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditAddress(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveAddress(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [address]
  );

  const addressTableInstance = useTable(
    {
      columns: addressColumns,
      data: address,
      initialState: { globalFilter: addressFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useResizeColumns
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex },
  } = addressTableInstance;

  useEffect(() => {
    const traineeId = localStorage.getItem("traineeId");
    if (!traineeId) {
      alert("Trainee ID is missing. Please log in.");
      return;
    }

    const fetchEducation = async () => {
      try {
        const educationResponse = await AxiosInstance.get(
          `companies/education/${traineeId}`
        );
        console.log("Education Response:", educationResponse.data);
        setEducation(educationResponse.data || []);
      } catch (error) {
        console.error("Error fetching education:", error);
      }
    };

    fetchEducation();
  }, []);

  // Fetch education options from the API, including qualifications
  useEffect(() => {
    const fetchEducationOptions = async () => {
      try {
        const response = await AxiosInstance.get("companies/educations/");
        if (response.status === 200) {
          console.log("Fetched education options:", response.data);
          setEducationOptions(response.data);

          // Map qualifications with both 'education_id' and 'qualification'
          const qualifications = response.data.map((education) => ({
            education_id: education.education_id,
            qualification: education.qualification,
          }));
          setQualificationOptions(qualifications); // Store qualifications with IDs in state
        } else {
          alert("Failed to fetch education options. Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching education options:", error);
        alert("Failed to fetch education options. Please try again later.");
      }
    };

    fetchEducationOptions();
  }, []);

  // Handle qualification change
  const handleQualificationChange = (e) => {
    const selectedOption = qualificationOptions.find(
      (option) => option.education_id.toString() === e.target.value
    );

    setEditedEducation({
      ...editedEducation,
      education: selectedOption?.education_id || "",
    });
  };

  // Handle edit of education
  const handleEditEducation = (index) => {
    const educationToEdit = education[index];
    const start = toDateInputValue(educationToEdit.year_of_starting);
    let pass = toDateInputValue(educationToEdit.year_of_passing);
    // Drop invalid existing pass-before-start values so the picker resets cleanly.
    if (start && pass && pass < start) {
      pass = "";
    }

    setEditingEducation(educationToEdit);

    setEditedEducation({
      ...educationToEdit,
      education:
        educationToEdit.education?.education_id ||
        educationToEdit.education ||
        "",
      year_of_starting: start,
      year_of_passing: pass,
    });
  };

  // Handle input change in education fields
  const handleEducationInputChange = (e) => {
    const { name, value } = e.target;
    setEditedEducation((prev) => {
      const next = { ...prev, [name]: value };
      const start = toDateInputValue(next.year_of_starting);
      const pass = toDateInputValue(next.year_of_passing);
      if (name === "year_of_starting" && start && pass && pass < start) {
        next.year_of_passing = "";
      }
      return next;
    });
  };

  // Handle save of education data
  const handleSaveEducation = async () => {
    if (!editedEducation?.trainee_education_id) {
      console.error("Education ID is missing.");
      return;
    }

    const dateError = validateEducationDates(
      editedEducation.year_of_starting,
      editedEducation.year_of_passing
    );
    if (dateError) {
      alert(dateError);
      return;
    }

    const payload = {
      education:
        editedEducation.education?.education_id || editedEducation.education,
      university: editedEducation.university,
      college_name: editedEducation.college_name,
      specialization: editedEducation.specialization,
      year_of_starting: toDateInputValue(editedEducation.year_of_starting),
      year_of_passing: toDateInputValue(editedEducation.year_of_passing),
      percentage_or_cgpa: editedEducation.percentage_or_cgpa,
    };

    try {
      await AxiosInstance.put(
        `companies/education/${editedEducation.trainee_education_id}/`,
        payload
      );

      const selectedEducationObj = educationOptions.find(
        (e) => e.education_id == payload.education
      );

      const updatedEducations = education.map((edu) =>
        edu.trainee_education_id === editedEducation.trainee_education_id
          ? {
              ...edu,
              ...payload,
              education: selectedEducationObj || {},
            }
          : edu
      );

      setEducation(updatedEducations);
      setEditingEducation(null);
    } catch (error) {
      console.error("Error saving education:", error);
    }
  };

  const handleRemoveEducation = async (index) => {
    const educationId = education[index]?.trainee_education_id;
    if (!educationId) return;

    const confirmed = window.confirm(
      "Are you sure you want to remove this education?"
    );
    if (!confirmed) return;

    try {
      await AxiosInstance.delete(`companies/trainee-education/${educationId}`);
      const updatedEducation = education.filter(
        (edu) => edu.trainee_education_id !== educationId
      );
      setEducation(updatedEducation);
    } catch (error) {
      console.error("Error removing education:", error);
    }
  };

  const educationColumns = React.useMemo(
    () => [
      { Header: "University Name", accessor: "university" },
      { Header: "College Name", accessor: "college_name" },
      { Header: "Qualification", accessor: "education.qualification" },
      { Header: "Specialization", accessor: "specialization" },
      { Header: "Year Of Starting", accessor: "year_of_starting" },
      { Header: "Year Of Passing", accessor: "year_of_passing" },
      { Header: "Percentage/CGPA", accessor: "percentage_or_cgpa" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditEducation(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveEducation(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [education]
  );

  const educationTableInstance = useTable(
    {
      columns: educationColumns,
      data: education || [],
      initialState: { globalFilter: educationFilter, pageSize: 7 }, // default page size
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination // Add pagination hook
  );

  const {
    getTableProps: getEducationTableProps,
    getTableBodyProps: getEducationTableBodyProps,
    headerGroups: educationHeaderGroups,
    prepareRow: prepareEducationRow,
    page: educationPage,
    state: { pageIndex: educationPageIndex },
    gotoPage: gotoEducationPage,
    pageCount: educationPageCount,
    nextPage: nextEducationPage,
    previousPage: previousEducationPage,
    canNextPage: canNextEducationPage,
    canPreviousPage: canPreviousEducationPage,
    setPageSize: setEducationPageSize,
    setGlobalFilter: setEducationGlobalFilter,
  } = educationTableInstance;

  useEffect(() => {
    const traineeId = localStorage.getItem("traineeId");

    AxiosInstance.get(`companies/certification/${traineeId}`)
      .then((res) => setCertification(res.data || []))
      .catch((err) => console.error("Error loading certifications:", err));

    AxiosInstance.get(`companies/certifications/`)
      .then((res) => setCertificationOptions(res.data || []))
      .catch((err) =>
        console.error("Error loading certification options:", err)
      );
  }, []);

  const handleEditCertification = (index) => {
    const selected = certification[index];
    const issue = toDateInputValue(selected.issue_date);
    let expiry = toDateInputValue(selected.expiry_date);
    if (issue && expiry && expiry <= issue) {
      expiry = "";
    }
    setEditingCertification(selected);
    setEditedCertification({
      ...selected,
      certification:
        selected.certification?.certification_id || selected.certification,
      issue_date: issue,
      expiry_date: expiry,
    });
  };

  const handleCertificationChange = (e) => {
    const { name, value } = e.target;
    setEditedCertification((prev) => {
      const next = { ...prev, [name]: value };
      const issue = toDateInputValue(next.issue_date);
      const expiry = toDateInputValue(next.expiry_date);
      if (name === "issue_date" && issue && expiry && expiry <= issue) {
        next.expiry_date = "";
      }
      return next;
    });
  };

  const handleSaveCertification = async () => {
    if (!editedCertification?.trainee_certification_id) return;

    const dateError = validateCertificationDates(
      editedCertification.issue_date,
      editedCertification.expiry_date
    );
    if (dateError) {
      alert(dateError);
      return;
    }

    const payload = {
      issue_authority: editedCertification.issue_authority,
      issue_date: toDateInputValue(editedCertification.issue_date),
      expiry_date: editedCertification.expiry_date
        ? toDateInputValue(editedCertification.expiry_date)
        : null,
      certification: editedCertification.certification,
    };

    try {
      await AxiosInstance.put(
        `companies/certification/${editedCertification.trainee_certification_id}/`,
        payload
      );

      const selectedCertObj = certificationOptions.find(
        (c) => c.certification_id == payload.certification
      );

      const updatedList = certification.map((item) =>
        item.trainee_certification_id ===
        editedCertification.trainee_certification_id
          ? {
              ...item,
              ...payload,
              certification: selectedCertObj || {},
            }
          : item
      );

      setCertification(updatedList);
      setEditingCertification(null);
    } catch (error) {
      console.error("Error updating certification:", error);
    }
  };

  const handleDeleteCertification = async (index) => {
    const id = certification[index]?.trainee_certification_id;
    if (!id) return;

    if (!window.confirm("Are you sure you want to remove this certification?"))
      return;

    try {
      await AxiosInstance.delete(`companies/trainee-certification/${id}`);
      setCertification((prev) =>
        prev.filter((cert) => cert.trainee_certification_id !== id)
      );
    } catch (err) {
      console.error("Failed to delete certification:", err);
    }
  };

  const certificationColumns = React.useMemo(
    () => [
      { Header: "Name", accessor: "certification.certification_name" },
      { Header: "Authority", accessor: "issue_authority" },
      { Header: "Issue Date", accessor: "issue_date" },
      { Header: "Expiry Date", accessor: "expiry_date" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditCertification(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteCertification(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [certification]
  );

  const certificationTableInstance = useTable(
    {
      columns: certificationColumns,
      data: certification || [],
      initialState: { globalFilter: certificationFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getCertificationTableProps,
    getTableBodyProps: getCertificationTableBodyProps,
    headerGroups: certificationHeaderGroups,
    prepareRow: prepareCertificationRow,
    page: certificationPage,
    state: { pageIndex: certificationPageIndex },
    gotoPage: gotoCertificationPage,
    pageCount: certificationPageCount,
    nextPage: nextCertificationPage,
    previousPage: previousCertificationPage,
    canNextPage: canNextCertificationPage,
    canPreviousPage: canPreviousCertificationPage,
    setPageSize: setCertificationPageSize,
    setGlobalFilter: setCertificationGlobalFilter,
  } = certificationTableInstance;

  useEffect(() => {
    const traineeId = localStorage.getItem("traineeId");

    // Fetch assigned skills
    AxiosInstance.get(`companies/skill/${traineeId}`)
      .then((res) => setSkill(res.data || []))
      .catch((err) => console.error("Error loading skills:", err));

    // Fetch master skill options
    AxiosInstance.get(`companies/skills/`)
      .then((res) => setSkillOptions(res.data || []))
      .catch((err) => console.error("Error loading skill options:", err));
  }, []);

  const handleEditSkill = (index) => {
    const selected = skill[index];
    setEditingSkill(selected);
    setEditedSkill({
      ...selected,
      skill: selected.skill?.skill_id || selected.skill,
    });
  };

  const handleSkillChange = (e) => {
    setEditedSkill({
      ...editedSkill,
      [e.target.name]: e.target.value,
    });
  };

 const handleSaveSkill = async () => {
  if (!editedSkill?.trainee_skill_id) return;

  const payload = {
    trainee: editedSkill.trainee,
    skill: editedSkill.skill,
    proficiency_level: editedSkill.proficiency_level,
  };

  try {
    const response = await AxiosInstance.put(
      `companies/skill/${editedSkill.trainee_skill_id}/`,
      payload
    );

    const selectedSkillObj = skillOptions.find(
      (s) => s.skill_id == response.data.skill
    );

    const updatedList = skill.map((item) =>
      item.trainee_skill_id === editedSkill.trainee_skill_id
        ? {
            ...item,
            ...response.data,
            skill: selectedSkillObj || item.skill, // 🔥 normalize
          }
        : item
    );

    setSkill(updatedList);
    setEditingSkill(null);
  } catch (error) {
    console.error(
      "Error updating skill:",
      error.response?.data || error.message
    );
  }
};


  const handleDeleteSkill = async (index) => {
    const skillToDelete = skill[index];
    const id = skillToDelete?.trainee_skill_id;
    if (!id) return;

    const confirmed = window.confirm(
      "Are you sure you want to remove this skill?"
    );
    if (!confirmed) return;

    try {
      await AxiosInstance.delete(`companies/trainee-skill/${id}`);

      const shouldGoToPreviousPage =
        skillPage.length === 1 && skillPageIndex > 0;
      const updatedSkills = skill.filter(
        (item) => item?.trainee_skill_id !== id
      );

      setSkill(updatedSkills);

      if (shouldGoToPreviousPage) {
        gotoSkillPage(skillPageIndex - 1);
      }
    } catch (err) {
      console.error("Failed to delete skill:", err);
    }
  };

  const skillColumns = React.useMemo(
    () => [
      { Header: "Skill Name", accessor: "skill.skill_name" },
      { Header: "Proficiency Level", accessor: "proficiency_level" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditSkill(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteSkill(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [skill]
  );

  const skillTableInstance = useTable(
    {
      columns: skillColumns,
      data: skill || [],
      initialState: { globalFilter: skillFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getSkillTableProps,
    getTableBodyProps: getSkillTableBodyProps,
    headerGroups: skillHeaderGroups,
    prepareRow: prepareSkillRow,
    page: skillPage,
    state: { pageIndex: skillPageIndex },
    gotoPage: gotoSkillPage,
    pageCount: skillPageCount,
    nextPage: nextSkillPage,
    previousPage: previousSkillPage,
    canNextPage: canNextSkillPage,
    canPreviousPage: canPreviousSkillPage,
    setPageSize: setSkillPageSize,
    setGlobalFilter: setSkillGlobalFilter,
  } = skillTableInstance;

  useEffect(() => {
    const traineeId = localStorage.getItem("traineeId");
    if (!traineeId) {
      alert("Trainee ID is missing. Please log in.");
      return;
    }

    const fetchSocialLink = async () => {
      try {
        const socialLinkResponse = await AxiosInstance.get(
          `companies/social_link/${traineeId}`
        );
        console.log("Socail Link Response:", socialLinkResponse.data);
        setSocialLink(socialLinkResponse.data || []);
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchSocialLink();
  }, []);

  const handleEditClick = (index) => {
    const selected = socialLink[index];
    setEditingSocialLink(selected); // store the original link
    setEditedSocialLink({ ...selected }); // store a copy to edit
  };

  const handleSaveSocialLink = async () => {
    if (!editedSocialLink || !editedSocialLink.social_link_id) {
      console.error("No social link selected for editing.");
      return;
    }

    try {
      const response = await AxiosInstance.put(
        `companies/social_link/${editedSocialLink.social_link_id}/`,
        editedSocialLink
      );

      if (response.status === 200) {
        console.log("Social link updated:", response.data);

        // Update the local state so UI reflects the change
        setSocialLink((prevLinks) =>
          prevLinks.map((link) =>
            link.social_link_id === response.data.social_link_id
              ? response.data
              : link
          )
        );

        // Close editing
        setEditingSocialLink(null);
        setEditedSocialLink(null);
      } else {
        console.error("Failed to update social link:", response);
      }
    } catch (error) {
      console.error("Error updating social link:", error);
    }
  };

  const handleDeleteSocialLink = async (index) => {
    const socialLinkId = socialLink[index]?.social_link_id;
    if (!socialLinkId) return;

    const confirmed = window.confirm(
      "Are you sure you want to remove this social link?"
    );
    if (!confirmed) return;

    try {
      await AxiosInstance.delete(
        `companies/trainee/social_link/${socialLinkId}`
      );
      const updatedSocialLink = socialLink.filter(
        (link) => link.social_link_id !== socialLinkId
      );
      setSocialLink(updatedSocialLink);
    } catch (error) {
      console.error("Error removing social link:", error);
    }
  };

  const socialLinkColumns = React.useMemo(
    () => [
      { Header: "Platform", accessor: "platform" },
      { Header: "URL", accessor: "url" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditClick(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteSocialLink(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [socialLink]
  );

  const socialLinkTableInstance = useTable(
    {
      columns: socialLinkColumns,
      data: socialLink || [],
      initialState: { globalFilter: socialLinkFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getSocialLinkTableProps,
    getTableBodyProps: getSocialLinkTableBodyProps,
    headerGroups: socialLinkHeaderGroups,
    prepareRow: prepareSocialLinkRow,
    page: socialLinkPage,
    state: { pageIndex: socialLinkPageIndex },
    gotoPage: gotoSocialLinkPage,
    pageCount: socialLinkPageCount,
    nextPage: nextSocialLinkPage,
    previousPage: previousSocialLinkPage,
    canNextPage: canNextSocialLinkPage,
    canPreviousPage: canPreviousSocialLinkPage,
    setPageSize: setSocialLinkPageSize,
    setGlobalFilter: setSocialLinkGlobalFilter,
  } = socialLinkTableInstance;

  if (!trainee) {
    return <div>Loading trainee details...</div>;
  }

  return (
    <div className="TraineePage als-trainee-page">
      <TraineeHeader />

      <div className="trainee-container py-4">
        <div className="mb-3">
          <button
            className="navigate-button btn btn-outline-primary d-flex align-items-center"
            onClick={() => navigate("/trainee-profile")}
            style={{ gap: "6px" }}
          >
            <FiArrowLeft /> Back to dashboard
          </button>
        </div>
        {/* PERSONAL DETAILS */}
        <h3 className="section-heading">Personal Details</h3>
        <div className="card-custom d-flex align-items-start gap-4 flex-wrap">
          <img
            src={
              trainee.image_path
                ? `${AxiosInstance.defaults.baseURL}/media/${trainee.image_path.replace(
                    /\\/g,
                    "/"
                  )}`
                : profile
            }
            alt="Profile"
            className="profile-image"
          />
          <div className="flex-grow-1">
            <div className="d-flex justify-content-between">
              <p>
                <strong>Name:</strong> {trainee.first_name} {trainee.last_name}
              </p>
              <button
                onClick={openModal}
                className="btn btn-sm btn-outline-primary"
              >
                <FiEdit />
              </button>
            </div>
            <p>
              <strong>Email:</strong> {trainee.email}
            </p>
            <p>
              <strong>Mobile Number:</strong> {trainee.mobile_no}
            </p>
            <p>
              <strong>Date Of Birth:</strong> {trainee.dob}
            </p>
            <p>
              <strong>Gender:</strong> {trainee.gender}
            </p>
          </div>
        </div>
        {isModalOpen && (
          <div
            className="modal d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Profile</h5>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        name="first_name"
                        className="form-control"
                        value={editedTrainee.first_name || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        name="last_name"
                        className="form-control"
                        value={editedTrainee.last_name || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={editedTrainee.email || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Mobile Number</label>
                      <input
                        type="text"
                        name="mobile_no"
                        className="form-control"
                        value={editedTrainee.mobile_no || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Gender</label>
                      <select
                        name="gender"
                        className="form-select"
                        value={editedTrainee.gender || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Date of Birth</label>
                      <input
                        type="date"
                        name="dob"
                        className="form-control"
                        value={editedTrainee.dob || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Profile Image</label>
                      <input
                        type="file"
                        name="image"
                        className="form-control"
                        accept="image/*"
                        onChange={(e) =>
                          setEditedTrainee({
                            ...editedTrainee,
                            image_file: e.target.files[0],
                          })
                        }
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleSave}>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ADDRESSES */}
        <h3 className="section-heading">Addresses</h3>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={addressFilter || ""}
              onChange={(e) => {
                setAddressFilter(e.target.value);
                setGlobalFilter(e.target.value);
              }}
              placeholder="Search addresses..."
            />
            <button className="add-button" onClick={() => handleAdd("address")}>
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getTableProps()}
            >
              <thead className="table-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {address.length === 0 ? (
                  <tr>
                    <td colSpan="8">No addresses found</td>
                  </tr>
                ) : (
                  page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination d-flex align-items-center gap-2 mt-3">
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="btn btn-sm btn-outline-primary"
            >
              Previous
            </button>
            <span>
              Page <strong>{pageIndex + 1}</strong> of{" "}
              <strong>{pageOptions.length}</strong>
            </span>
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="btn btn-sm btn-outline-primary"
            >
              Next
            </button>
          </div>
          {editingAddress && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Address</h5>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3 position-relative">
                        <label className="form-label">Search Address</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Type address..."
                          value={editAddressSearch}
                          onChange={(e) => setEditAddressSearch(e.target.value)}
                        />
                        {editSuggestions.length > 0 && (
                          <ul
                            className="list-group position-absolute w-100"
                            style={{ zIndex: 999 }}
                          >
                            {editSuggestions.map((item, index) => (
                              <li
                                key={index}
                                className="list-group-item list-group-item-action"
                                onClick={() =>
                                  handleEditAddressSelect(item.place_id)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                {item.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Address Line 1</label>
                        <input
                          type="text"
                          name="address_line1"
                          className="form-control"
                          value={editedAddress?.address_line1 || ""}
                          onChange={handleAddressInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Address Line 2</label>
                        <input
                          type="text"
                          name="address_line2"
                          className="form-control"
                          value={editedAddress?.address_line2 || ""}
                          onChange={handleAddressInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          value={editedAddress?.city || ""}
                          onChange={handleAddressInputChange}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Country</label>
                          <select
                            name="country"
                            className="form-select"
                            value={editedAddress?.country || ""}
                            onChange={handleCountryChange}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option
                                key={country.country_id}
                                value={country.country_id}
                              >
                                {country.country_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="form-label">State</label>
                          <select
                            name="state"
                            className="form-select"
                            value={editedAddress?.state || ""}
                            onChange={handleStateChange}
                            disabled={!country}
                          >
                            <option value="">Select State</option>
                            {states.map((state) => (
                              <option
                                key={state.state_id}
                                value={state.state_id}
                              >
                                {state.state_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Address Type</label>
                        <select
                          name="address_type"
                          className="form-select"
                          value={editedAddress?.address_type || ""}
                          onChange={handleAddressTypeChange}
                        >
                          <option value="">Select Address Type</option>
                          {addressTypeOptions.map((type) => (
                            <option
                              key={type.address_type_id}
                              value={type.address_type_id}
                            >
                              {type.address_type}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Zip Code</label>
                        <input
                          type="text"
                          name="zip_code"
                          className="form-control"
                          value={editedAddress?.zip_code || ""}
                          onChange={handleAddressInputChange}
                        />
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingAddress(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveAddress}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* EDUCATION SECTION */}
        <h3 className="section-heading">Educations</h3>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={educationFilter || ""}
              onChange={(e) => {
                setEducationFilter(e.target.value);
                setEducationGlobalFilter(e.target.value);
              }}
              placeholder="Search education..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("education")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getEducationTableProps()}
            >
              <thead className="table-light">
                {educationHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getEducationTableBodyProps()}>
                {education.length === 0 ? (
                  <tr>
                    <td colSpan="8">No educations found</td>
                  </tr>
                ) : (
                  educationPage.map((row) => {
                    prepareEducationRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination d-flex align-items-center gap-2 mt-3">
            <button
              onClick={() => previousEducationPage()}
              disabled={!canPreviousEducationPage}
              className="btn btn-sm btn-outline-primary"
            >
              Previous
            </button>
            <span>
              Page <strong>{educationPageIndex + 1}</strong> of{" "}
              <strong>{educationTableInstance.pageOptions.length}</strong>
            </span>
            <button
              onClick={() => nextEducationPage()}
              disabled={!canNextEducationPage}
              className="btn btn-sm btn-outline-primary"
            >
              Next
            </button>
          </div>

          {editingEducation && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Education</h5>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">University</label>
                          <input
                            type="text"
                            name="university"
                            className="form-control"
                            value={editedEducation?.university || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">College Name</label>
                          <input
                            type="text"
                            name="college_name"
                            className="form-control"
                            value={editedEducation?.college_name || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Qualification</label>
                        <select
                          name="education"
                          className="form-select"
                          value={editedEducation?.education || ""}
                          onChange={handleEducationInputChange}
                        >
                          <option value="">Select Qualification</option>
                          {qualificationOptions.map((option) => (
                            <option
                              key={option.education_id}
                              value={option.education_id}
                            >
                              {option.qualification}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Specialization</label>
                        <input
                          type="text"
                          name="specialization"
                          className="form-control"
                          value={editedEducation?.specialization || ""}
                          onChange={handleEducationInputChange}
                        />
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Year of Starting</label>
                          <input
                            type="date"
                            name="year_of_starting"
                            className="form-control"
                            value={toDateInputValue(
                              editedEducation?.year_of_starting
                            )}
                            max={todayInputValue()}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Year of Passing</label>
                          <input
                            type="date"
                            name="year_of_passing"
                            className="form-control"
                            value={toDateInputValue(
                              editedEducation?.year_of_passing
                            )}
                            min={
                              toDateInputValue(
                                editedEducation?.year_of_starting
                              ) || undefined
                            }
                            max={yearsFromTodayInputValue(15)}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Percentage / CGPA</label>
                        <input
                          type="number"
                          step="0.01"
                          name="percentage_or_cgpa"
                          className="form-control"
                          value={editedEducation?.percentage_or_cgpa || ""}
                          onChange={handleEducationInputChange}
                        />
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingEducation(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveEducation}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* CERTIFICATION SECTION */}
        <h3 className="section-heading">Certifications</h3>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={certificationFilter || ""}
              onChange={(e) => {
                setCertificationFilter(e.target.value);
                setCertificationGlobalFilter(e.target.value);
              }}
              placeholder="Search certification records..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("certification")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getCertificationTableProps()}
            >
              <thead className="table-light">
                {certificationHeaderGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    key={headerGroup.id}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        key={column.id}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getCertificationTableBodyProps()}>
                {certification.length === 0 ? (
                  <tr>
                    <td
                      colSpan={
                        certificationHeaderGroups[0]?.headers.length || 8
                      }
                      className="text-center"
                    >
                      No certifications found
                    </td>
                  </tr>
                ) : (
                  certificationPage.map((row) => {
                    prepareCertificationRow(row);
                    return (
                      <tr {...row.getRowProps()} key={row.id}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()} key={cell.column.id}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            <div className="pagination d-flex align-items-center gap-2 mt-3">
              <button
                onClick={() => previousCertificationPage()}
                disabled={!canPreviousCertificationPage}
                className="btn btn-sm btn-outline-primary"
              >
                Previous
              </button>
              <span>
                Page <strong>{certificationPageIndex + 1}</strong> of{" "}
                <strong>{certificationTableInstance.pageOptions.length}</strong>
              </span>
              <button
                onClick={() => nextCertificationPage()}
                disabled={!canNextCertificationPage}
                className="btn btn-sm btn-outline-primary"
              >
                Next
              </button>
            </div>
          </div>

          {editingCertification && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Certification</h5>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label className="form-label">Certification</label>
                        <select
                          name="certification"
                          className="form-select"
                          value={editedCertification?.certification || ""}
                          onChange={handleCertificationChange}
                        >
                          <option value="">Select Certification</option>
                          {certificationOptions.map((cert) => (
                            <option
                              key={cert.certification_id}
                              value={cert.certification_id}
                            >
                              {cert.certification_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Issue Authority</label>
                        <input
                          type="text"
                          name="issue_authority"
                          className="form-control"
                          value={editedCertification?.issue_authority || ""}
                          onChange={(e) =>
                            setEditedCertification({
                              ...editedCertification,
                              issue_authority: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Issue Date</label>
                          <input
                            type="date"
                            name="issue_date"
                            className="form-control"
                            value={toDateInputValue(
                              editedCertification?.issue_date
                            )}
                            max={todayInputValue()}
                            onChange={handleCertificationChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Expiry Date</label>
                          <input
                            type="date"
                            name="expiry_date"
                            className="form-control"
                            value={toDateInputValue(
                              editedCertification?.expiry_date
                            )}
                            min={
                              dayAfterInputValue(
                                editedCertification?.issue_date
                              ) || undefined
                            }
                            onChange={handleCertificationChange}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Certificate Path</label>
                        <input
                          type="text"
                          name="certificate_path"
                          className="form-control"
                          value={editedCertification?.certificate_path || ""}
                          onChange={(e) =>
                            setEditedCertification({
                              ...editedCertification,
                              certificate_path: e.target.value,
                            })
                          }
                        />
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingCertification(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveCertification}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* SKILL SECTION — managed in Career preference */}
        <h3 className="section-heading">Skills</h3>
        <div className="card-custom">
          <p className="text-muted mb-3">
            Manage your skills in Career preference. They are used to match jobs,
            internships, and trainings.
          </p>
          {skill.length === 0 ? (
            <p className="text-muted mb-3">No skills added yet.</p>
          ) : (
            <ul className="list-group mb-3">
              {skill.slice(0, 8).map((item) => (
                <li
                  key={item.trainee_skill_id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <span>
                    <strong>
                      {item.skill?.skill_name || item.skill_name || "Skill"}
                    </strong>
                    {item.proficiency_level ? (
                      <span className="text-muted"> · {item.proficiency_level}</span>
                    ) : null}
                  </span>
                </li>
              ))}
            </ul>
          )}
          <button
            type="button"
            className="btn1"
            onClick={() => navigate("/trainee-career-preference")}
          >
            Manage skills
          </button>
        </div>
        {/* Social Link SECTION */}
        <h3 className="section-heading">Social Links</h3>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={socialLinkFilter || ""}
              onChange={(e) => {
                setSocialLinkFilter(e.target.value);
                setSocialLinkGlobalFilter(e.target.value);
              }}
              placeholder="Search social Link records..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("social-Link")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getSocialLinkTableProps()}
            >
              <thead className="table-light">
                {socialLinkHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getSocialLinkTableBodyProps()}>
                {socialLink.length === 0 ? (
                  <tr>
                    <td colSpan="8">No social Links found</td>
                  </tr>
                ) : (
                  socialLinkPage.map((row) => {
                    prepareSocialLinkRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination d-flex align-items-center gap-2 mt-3">
            <button
              onClick={() => previousSocialLinkPage()}
              disabled={!canPreviousSocialLinkPage}
              className="btn btn-sm btn-outline-primary"
            >
              Previous
            </button>
            <span>
              Page <strong>{socialLinkPageIndex + 1}</strong> of{" "}
              <strong>{socialLinkTableInstance.pageOptions.length}</strong>
            </span>
            <button
              onClick={() => nextSocialLinkPage()}
              disabled={!canNextSocialLinkPage}
              className="btn btn-sm btn-outline-primary"
            >
              Next
            </button>
          </div>

          {editingSocialLink && (
            <div
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "1rem",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 1050,
              }}
            >
              <div className="container py-4">
                <div
                  className="card mx-auto shadow"
                  style={{ maxWidth: "480px" }}
                >
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Edit Social Link</h5>
                  </div>
                  <form className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Platform</label>
                      <input
                        type="text"
                        className="form-control"
                        name="platform"
                        value={editedSocialLink?.platform || ""}
                        onChange={(e) =>
                          setEditedSocialLink({
                            ...editedSocialLink,
                            platform: e.target.value,
                          })
                        }
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label className="form-label">URL</label>
                      <input
                        type="url"
                        className="form-control"
                        name="url"
                        value={editedSocialLink?.url || ""}
                        onChange={(e) =>
                          setEditedSocialLink({
                            ...editedSocialLink,
                            url: e.target.value,
                          })
                        }
                        placeholder="https://your-link.com"
                        required
                      />
                    </div>
                  </form>

                  <div className="card-footer d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingSocialLink(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveSocialLink}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footers />
    </div>
  );
}
